import type {
	LinkedMissingFieldHandler,
	MissingFieldHandler,
	NormalizationLinkedField,
	ReaderLinkedField,
	ReadOnlyRecordProxy,
	Variables,
} from 'relay-runtime';

import { JiraFilterAri } from '@atlassian/ari/jira/filter';
import RelayDataID from '@atlassian/relay-data-id';

const isCustomFilter = (filterId: string) => /^\d+$/.test(filterId);
const isSystemFilter = (filterId: string) => /^-\d+$/.test(filterId);

export const JiraQueryFilterMissingFieldHandler: LinkedMissingFieldHandler = {
	handle: (
		field: NormalizationLinkedField | ReaderLinkedField,
		record: ReadOnlyRecordProxy | null | undefined,
		argValues: Variables,
	) => {
		// https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/

		// This lets relay know that a query of
		// JiraQuery.filter(id: ID!)
		// can return:
		//   - a JiraCustomFilter object
		//   - a JiraSystemFilter object
		// determined by the type encoded within the id field (which is an ARI type).
		// By providing the id that relay would refer to those objects by, it is able to check it's
		// store to see if they are already fetched, and avoid refetching them if it is unnecessary
		if (
			record != null &&
			record.getType() === 'JiraQuery' &&
			field.name === 'filter' &&
			argValues.id != null
		) {
			const { id } = argValues;
			const filterId = JiraFilterAri.parse(id).filterId;
			if (isCustomFilter(filterId)) {
				return RelayDataID({ id }, 'JiraCustomFilter');
			}
			if (isSystemFilter(filterId)) {
				return RelayDataID({ id }, 'JiraSystemFilter');
			}
			return undefined;
		}
		return undefined;
	},
	kind: 'linked',
};

const MissingFieldHandlers: ReadonlyArray<MissingFieldHandler> = [
	JiraQueryFilterMissingFieldHandler,
];
export default MissingFieldHandlers;
